module.exports = __webpack_public_path__ + "static/media/PartyTotalsSocial.a98937c1.jpg";